<template>
    <div style="width:1180px;margin:50px auto;background-color:#FFF;">
        <!-- Modal -->
        <div class="modal fade" id="myModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">Message</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <template v-for="(errMsg, index) in errMsgs">
                    <div>
                        {{ errMsg }}
                    </div>
                    </template>
                </div>
                <div class="modal-footer">
                    <button v-show="modalType == 'success' || modalType == 'error'" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
                </div>
            </div>
        </div>

        <!-- loading -->
        <div class="loading" v-show="pageLoading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <div style="text-align: left;padding: 20px;font-size: 18px;" v-show="isSSO == true" class="title">
            Armstrong task assignment rule for non AMI customer
            <div class="infoDiv" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="right"
          title="當在特定城市指派一名SR時，請注意每個城市僅能設定一次。">
              <font-awesome-icon icon="fa-solid fa-circle-info" style="font-size: 13px;margin-bottom: 2px;" />
            </div>
        </div>
        <div style="border: 2px solid #cccccc;border-radius:10px;" v-show="isSSO == true" v-loading="listLoading">
            <table style="width:100%;" >
                <tr style="font-size: 18px;text-align: left;height: 40px;border-bottom: 2px solid #cccccc;">
                    <td class="tempClass">
                        <div style="padding-left:60px;width:50%;">City of Contact</div>
                    </td>
                    <td style="background-color:#EAF1FA;width:50%;border-top-right-radius:10px 10px;">
                        Assign to SR
                    </td>
                </tr>
                <template v-for='(rowValue, index) in armStrongList'>
                    <tr v-if="index==0" style="border-bottom: 2px solid #cccccc;" v-bind:key="index">
                        <td>
                            <div class="rowdiv" style="height:40px;">
                                <div style="float:left;">
                                    <input class="rowdiv_div2" style="width: 30px;" type="checkbox" v-model="rowValue.NoCityInformation" @change="changeCheckbox"/>
                                </div>
                                <div style="float:left;line-height:40px;height:40px;padding-left:10px;">
                                    No city information
                                </div>
                            </div>
                        </td>
                        <td>
                            <div style="width:90%;">
                                <div v-show="rowValue.SRIdError != ''" style="height:21px;">
                                    &nbsp;
                                </div>
								<multiselect placeholder="請輸入Salesperson ID" v-model="rowValue.SRId" label="Armstrong2SalespersonsId" track-by="Armstrong2SalespersonsId"
												v-bind:options="salesPersons" v-bind:taggable="false" v-bind:multiple="false" v-bind:allow-empty="false" v-bind:disabled="rowValue.NoCityInformation === false">
									<span slot="noResult">尚無此Salesperson</span>
								</multiselect>
                                <!-- <input style="height: 44px;" type="text" placeholder="請輸入Salesperson ID" onKeyUp="value=value.replace(/[\W]/g,'')" v-model="rowValue.SRId" v-bind:class="[{ 'form-control': true }, { 'is-invalid': rowValue.SRIdError != '' }]" v-bind:disabled="rowValue.CityOfContact.length === 0"/> -->
                                <!-- <input style="height: 44px;" type="text" placeholder="請輸入Salesperson ID" onKeyUp="value=value.replace(/[\W]/g,'')" v-model="rowValue.SRId" v-bind:class="[{ 'form-control': true }, { 'is-invalid': rowValue.SRIdError != '' }]" v-bind:disabled="rowValue.NoCityInformation === false"/> -->
                                <div v-show="rowValue.SRIdError != ''" class="invalid-feedback" style="text-align: left;display: block;">
                                    {{ rowValue.SRIdError }}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-else style="border-bottom: 2px solid #cccccc;">
                        <td style="padding: 10px 0px;">
                            <div style="min-height: 45px;padding: 0px 50px 0px 20px;">
                                <div v-show="rowValue.CityOfContactError != ''" style="height:21px;">
                                    &nbsp;
                                </div>
                                <multiselect v-model="rowValue.CityOfContact" :options="options" :multiple="true" v-bind:class="[{ 'is-invalid': rowValue.CityOfContactError != '' }]"></multiselect>
                                <div v-show="rowValue.CityOfContactError != ''" class="invalid-feedback" style="text-align: left;">
                                    {{ rowValue.CityOfContactError }}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div style="float:left;width:90%;">
                                <div v-show="rowValue.SRIdError != ''" style="height:21px;">
                                    &nbsp;
                                </div>
								<multiselect placeholder="請輸入Salesperson ID" v-model="rowValue.SRId" label="Armstrong2SalespersonsId" track-by="Armstrong2SalespersonsId"
												v-bind:options="salesPersons" v-bind:taggable="false" v-bind:multiple="false" v-bind:allow-empty="false">
									<span slot="noResult">尚無此Salesperson</span>
								</multiselect>
                                <!-- <input style="height: 44px;" type="text" placeholder="請輸入Salesperson ID" onKeyUp="value=value.replace(/[\W]/g,'')" v-model="rowValue.SRId" v-bind:class="[{ 'form-control': true }, { 'is-invalid': rowValue.SRIdError != '' }]" v-bind:disabled="rowValue.CityOfContact.length === 0"/> -->
                                <div v-show="rowValue.SRIdError != ''" class="invalid-feedback" style="text-align: left;display: block;">
                                    {{ rowValue.SRIdError }}
                                </div>
                            </div>
                            <div style="float:left;width:10%;padding-right: 10px;height: 44px;line-height: 44px;color:#D9432D;" v-on:click="deleteRow(index)">
                                <div v-show="rowValue.SRIdError != ''" style="height:21px;">
                                    &nbsp;
                                </div>
                                <font-awesome-icon icon="fa-solid fa-trash-can" style="font-size:17px;padding-left: 4px;cursor:pointer;"/>
                            </div>
                        </td>
                    </tr>
                </template>
                <tr style="">
                    <td>
                        <div class="rowdiv" style="height:40px;padding-bottom: 40px;">
                            <div style="float:left;border: 1px solid #ccc;border-radius: 99px;width: 25px;height:25px;color:#2C70CB;cursor:pointer;" v-on:click="addRow">
                                <font-awesome-icon icon="fa-solid fa-plus" style="font-size:17px;padding-left: 4px;"/>
                            </div>
                            <div style="float:left;line-height:25px;height:25px;padding-left:10px;">
                                Add the assignment rule
                            </div>
                        </div>
                    </td>
                    <td>
                        <div style="">
                            <button type="button" class="btn btn-primary" style="float: right;margin: 10px 20px 10px;background-color:#003968;" v-on:click="save">Save</button>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { doAuth, doAuth2 } from '@/api/authorized'
import { getArmStrongList, insertArmStrongList, deleteAllArmStrongList, getSrList } from '@/api/arm-strong'
import Multiselect from 'vue-multiselect'
export default {
  components: { Multiselect },
  name: 'ArmstrongTemplate',
  data: function () {
    return {
      pageLoading: true,
      listLoading: false,
      errMsgs: [],
      salesPersons: [],
      modalType: '',
      options: ['台北市', '新北市', '基隆市', '新竹市', '桃園市', '新竹縣', '宜蘭縣', '台中市', '苗栗縣', '彰化縣', '南投縣', '雲林縣', '高雄市', '台南市', '嘉義市', '嘉義縣', '屏東縣', '澎湖縣', '花蓮縣', '台東縣', '金門縣', '連江縣'],
      armStrongList: [],
      // SSO
      isSSO: false,
      host: '',
      redirectPage: '',
      code: null,
      redirectUrl: '',
      pageName: 'armstrong',
      token: '',
      refreshToken: ''
    }
  },
  watch: {
  },
  created () {
    this.host = process.env.VUE_SERVER_DOMAIN;
    this.redirectPage = this.$route.query.redirect == undefined ? 'armstrong' : this.$route.query.redirect;
    if (this.redirectPage == null && this.code == null) {
      alert('登錄資訊錯誤');
      return;
    }

    this.redirectUrl = "https://" + this.host + "/armstrong?redirect=" + this.redirectPage.replace("/", "")
    this.code = this.$route.query.code == undefined ? 0 : this.$route.query.code;

    if (this.code != 0) {
      let req = {
        page: this.redirectPage,
        code: this.code,
        redirect_uri: this.redirectUrl
      };

      doAuth2(req).then(res => {
        if (res.Success) {
          if (res.AccessToken) {
            //this.$store.dispatch("resetToken", res.AccessToken.access_token);
            //this.$store.dispatch("resetRefreshToken", res.AccessToken.refresh_token);
            this.token = res.AccessToken.access_token;
            this.refreshToken = res.AccessToken.refresh_token;
            this.isSSO = true;
            this.$router.push(this.redirectPage).catch(() => {});
			this.getsrListData();
            this.fetchData();
            this.pageLoading = false;
          }
        }
      });
    } else if (this.redirectPage != null && this.code == 0) {
      let req = {
        page: this.redirectPage
      };

      doAuth(req).then(res => {
        if (res.Success) {
          let targetUrl = res.TargetUrl.replace(
            "{{redirect_url}}",
            this.redirectUrl
          );
          window.location.href = targetUrl
        }
      });
    }
  },
  mounted () {
    //this.fetchData()
    this.initTooltip()
  },
  updated () {
  },
  methods: {
    initTooltip: function () {
      this.$nextTick(function () {
        var tooltipTriggerList = [].slice.call(
          document.querySelectorAll('[data-bs-toggle="tooltip"]')
        )
        // eslint-disable-next-line no-unused-vars
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
          // eslint-disable-next-line no-undef
          return new bootstrap.Tooltip(tooltipTriggerEl)
        })
      })
    },
    changeCheckbox () {
      if (this.armStrongList.length > 0) {
        if (this.armStrongList[0].NoCityInformation === false) {
          this.armStrongList[0].SRId = ''
        }
      }
    },
	getsrListData(){
		let req = {}
		req.pageName = this.pageName
		req.token = this.token
		req.refreshToken = this.refreshToken
		getSrList(req).then((res)=>{
			this.salesPersons = res.dataList
		}).catch(() => {
			const errMsgs = []
			errMsgs.push('網路連線異常')
			this.modalType = 'error'
			this.showModal(errMsgs)
		})
	},
    fetchData () {
      let req = {}
      req.pageName = this.pageName
      req.token = this.token
      req.refreshToken = this.refreshToken
      getArmStrongList(req).then((res) => {
        //token
        this.token =  res.token.access_token
        this.refreshToken =  res.token.refresh_token
        //資料
        if (res.dataList.length === 0) {
          const tmp = {}
          tmp.NoCityInformation = false
          tmp.CityOfContact = ''
          tmp.CityOfContactError = ''
          tmp.SRId = ''
          tmp.SRIdError = ''
          this.armStrongList.push(tmp)
        } else {
          for (let i = 0; i < res.dataList.length; i++) {
            if (res.dataList[i].CityOfContact !== '') {
              res.dataList[i].CityOfContact = res.dataList[i].CityOfContact.split(';')
            }
			if (res.dataList[i].SRId !== '') {
              res.dataList[i].SRId = {"Armstrong2SalespersonsId":res.dataList[i].SRId}
            }
            res.dataList[i].CityOfContactError = ''
            res.dataList[i].SRIdError = ''
          }
          this.armStrongList = res.dataList
        }
        // this.fixfetchData()
      }).catch(() => {
        const errMsgs = []
        errMsgs.push('網路連線異常')
        this.modalType = 'error'
        this.showModal(errMsgs)
      })
    },
    addRow () {
      const tmp = {}
      tmp.NoCityInformation = false
      tmp.CityOfContact = ''
      tmp.CityOfContactError = ''
      tmp.SRId = ''
      tmp.SRIdError = ''
      this.armStrongList.push(tmp)
    },
    deleteRow (index) {
      this.armStrongList.splice(index, 1)
    },
    save () {
      this.listLoading = true
      let isError = Boolean(false)
	  let saveCityOfContactMap = new Map();
      for (let i = 0; i < this.armStrongList.length; i++) {
        this.armStrongList[i].CityOfContactError = ''
        this.armStrongList[i].SRIdError = ''
        if (i === 0) {
          if (this.armStrongList[i].SRId === '' && this.armStrongList[i].NoCityInformation) {
            isError = true
            this.armStrongList[i].SRIdError = '請輸入Salesperson ID'
          }
        } else {
          if (this.armStrongList[i].CityOfContact === '') {
            isError = true
            this.armStrongList[i].CityOfContactError = '請輸入City of Contact'
          }
          if (this.armStrongList[i].SRId === '') {
            isError = true
            this.armStrongList[i].SRIdError = '請輸入Salesperson ID'
          }
		  if(this.armStrongList[i].CityOfContact != '' && this.armStrongList[i].SRId != ''){
			//duplicate search
			let cloneCityOfContact = JSON.parse(JSON.stringify(this.armStrongList[i].CityOfContact));
			cloneCityOfContact = cloneCityOfContact.sort();
			let key = cloneCityOfContact+"_"+this.armStrongList[i].SRId.Armstrong2SalespersonsId;
			let indexs = []
			if(saveCityOfContactMap.has(key)){
				indexs = saveCityOfContactMap.get(key);
				indexs.push(i)
				saveCityOfContactMap.set(key,indexs);
			}else{
				indexs = [i]
				saveCityOfContactMap.set(key,indexs);
			}
		  }
        }
      }
	  for(const values of saveCityOfContactMap.values()){
		if(values.length>1){
			for(const i of values){
				isError = true
				this.armStrongList[i].SRIdError = '該筆資料存在重複值，請檢查填寫情況'
			}
		}
	  }
      if (!isError) {
        // 先全部刪除，在全部新建
        let req = {}
        req.pageName = this.pageName
        req.token = this.token
        req.refreshToken = this.refreshToken
        deleteAllArmStrongList(req).then((res) => {
          //token
          this.token =  res.token.access_token
          this.refreshToken =  res.token.refresh_token
          //資料
          if (res.dataList === null) {
            // 建立新資料
            const req = []
            for (let i = 0; i < this.armStrongList.length; i++) {
              // let tmpReq = JSON.parse(JSON.stringify(this.armStrongList[i]))
              let tmpReq = {...this.armStrongList[i]}
              if (i > 0) {
                tmpReq.CityOfContact = tmpReq.CityOfContact.join(';')
              }
			  tmpReq.SRId = tmpReq.SRId.Armstrong2SalespersonsId
              req.push(tmpReq)
            }
            let tmpReq = {}
            tmpReq.pageName = this.pageName
            tmpReq.token = this.token
            tmpReq.refreshToken = this.refreshToken
            tmpReq.data = req
            ///緊接著下一個資料，就不檢查Token了
            insertArmStrongList(tmpReq).then((res) => {
              //token
              this.token =  res.token.access_token
              this.refreshToken =  res.token.refresh_token
              //資料
              if (res.err === null) {
                let errMsgs = []
                this.modalType = 'success'
                errMsgs.push('儲存成功')
                this.showModal(errMsgs)
                this.listLoading = false
              }
              else
              {
                const errMsgs = []
                errMsgs.push('網路連線異常')
                this.modalType = 'error'
                this.showModal(errMsgs)
                this.listLoading = false
              }
            })
          }
        })
      }
      else {
        this.listLoading = false
      }
    },
    showModal: function (errMsgs) {
      // eslint-disable-next-line no-undef
      const myModal = new bootstrap.Modal(document.getElementById('myModal'))
      this.errMsgs = errMsgs
      myModal.show()
    }
  }
}
</script>
<style>
.title {
  display: flex;
  gap: 6px;
}

.loading {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: .5;
}

.spinner-border {
  margin-top: 30%;
  width: 5rem;
  height: 5rem;
}

tr{
    height: 65px;
}
.rowdiv {
    width:calc(50% - 0px);
    text-align: left;
    padding:15px 20px;
}
.rowdiv_div1 {
    margin-bottom: 4px;
}
.rowdiv_div2 {
    width:100%;
    height:40px;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    padding: 0px 10px;
}
.tempClass {
  background-color:#EAF1FA;border-top-left-radius:10px 10px;
}
</style>
